/**
 * Created by javier on 9/20/17.
 */
import Vue from 'vue';
export const EventBus = new Vue();